// Web panel → Chrome Extension iletişimi
// Token'ı extension storage'a otomatik gönderir

const EXTENSION_ID_KEY = "erc_extension_id";

type ChromeRuntime = {
  sendMessage: (
    extensionId: string,
    message: unknown,
    callback: (response: { success?: boolean } | undefined) => void
  ) => void;
  lastError?: { message?: string };
};

declare global {
  interface Window {
    chrome?: { runtime?: ChromeRuntime };
  }
}

export function saveExtensionId(extensionId: string) {
  localStorage.setItem(EXTENSION_ID_KEY, extensionId);
}

export function getExtensionId(): string | null {
  return localStorage.getItem(EXTENSION_ID_KEY);
}

export async function sendTokenToExtension(token: string): Promise<boolean> {
  const runtime = window.chrome?.runtime;
  if (!runtime) return false;

  const extensionId = getExtensionId();
  if (!extensionId) return false;

  return new Promise((resolve) => {
    try {
      runtime.sendMessage(
        extensionId,
        { type: "SET_AUTH_TOKEN", payload: token },
        (response) => {
          if (runtime.lastError) {
            resolve(false);
          } else {
            resolve(response?.success === true);
          }
        }
      );
    } catch {
      resolve(false);
    }
  });
}

/** Eklentiye mesaj gonderir; eklenti yoksa/yanit vermezse null doner. */
export function callExtension<T>(message: unknown): Promise<T | null> {
  const runtime = window.chrome?.runtime;
  const extensionId = getExtensionId();
  if (!runtime || !extensionId) return Promise.resolve(null);
  return new Promise((resolve) => {
    try {
      runtime.sendMessage(extensionId, message, (response) => {
        resolve(runtime.lastError ? null : ((response as unknown as T | undefined) ?? null));
      });
    } catch {
      resolve(null);
    }
  });
}

export async function pingExtension(): Promise<string | null> {
  const r = await callExtension<{ success?: boolean; version?: string }>({ type: "ERC_PING" });
  return r?.success ? r.version ?? "?" : null;
}
